import { useMemo } from 'react';
import { format } from 'date-fns';

import { datePosition } from '../utils/date-position';

export type TimelineTodayLineProps = {
  start: Date;
  end: Date;
  now: Date;
};

export function TimelineTodayLine({ now, start, end }: TimelineTodayLineProps) {
  const todayPosition = useMemo<number | undefined>(
    function () {
      const position = datePosition(now, start, end);

      if (position < 0 || position > 1) {
        return undefined;
      }

      return position;
    },
    [now, start, end],
  );

  // outside of the timeline
  if (!todayPosition) {
    return null;
  }

  return (
    <div
      className="absolute inset-y-0 top-6 w-px bg-red-500"
      style={{ left: `${todayPosition * 100}%` }}
    >
      <div className="group absolute left-1/2 top-0 -translate-x-1/2 cursor-default rounded bg-red-500 px-2 py-1 text-xs text-white">
        <div className="transition-opacity duration-300 ease-in-out group-hover:opacity-0">
          Today
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100">
          {format(now, 'MMM d')}
        </div>
      </div>
    </div>
  );
}
